import { SAPContact } from '../../types';
import { fetchWithCredentials } from './client';

interface ContactsApiResponse {
  success: boolean;
  data: SAPContact[];
}

export const contactsApi = {
  async search(query: string, signal?: AbortSignal): Promise<SAPContact[]> {
    const encodedQuery = encodeURIComponent(query);
    const response = await fetchWithCredentials<ContactsApiResponse>(
      `/api/v1/contacts/search?query=${encodedQuery}`,
      { method: 'GET', signal }
    );
    return response.data;
  },
};
